<template>
  <div class="login">
    <div class="logo">
      SUSHI CLUB
    </div>
    <div class="login-container">
      <van-field
        v-model="ruleForm.username"
        class="username"
        left-icon="friends"
        placeholder="请输入用户名称"
      />
      <van-field
        v-model="ruleForm.password"
        class="password"
        left-icon="lock"
        placeholder="请输入登录密码"
        type="password"
      />
      <van-button
        class="login-button"
        type="primary"
        block
        size="small"
        @click="login"
      >
        登录
      </van-button>
    </div>
  </div>
</template>
<script>
import { Login } from '@/api/login'
export default {
  name: "Index",
  data() {
    return {
      ruleForm: {
        username: '',
        password: ''
      }
    };
  },
  created() {
    if(localStorage.getItem('sushiWechatToken'))
    this.$router.replace({path: '/index'})
  },
  methods: {
    login(){
			this.$toast.loading({
				duration: 0,
				message: '正在登录',
				forbidClick: true,
      });
      Login(this.ruleForm).then(res => {
        this.$toast.clear();
        if(res.code === 0){
          localStorage.setItem('sushiWechatToken', res.token);
          localStorage.setItem('isIncomeOut', res.userInfo.isIncomeOut);
          localStorage.setItem('sushiWechatShopInfo', JSON.stringify(res.shopInfo));
          this.$router.replace({path: '/index'})
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
  .login{
    background: rgb(42, 144, 223);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // background: url("../../assets/login.jpg") center no-repeat;

    .logo{
      text-align: center;
      line-height: 75px;
      margin-bottom: 20px;
      color: #fff;
    }
    .login-container{
      padding: 40px;
      box-sizing: border-box;
      width: 100%;
      margin-bottom: 200px;
    }
    .login-button{
      margin-top: 40px;
      border-radius: 10px;
    }
    .username{
      border-radius: 10px 10px 0 0;
    }
    .password{
      border-radius: 0 0 10px 10px;
    }
  }
</style>